import { SxProps, TextField, Theme } from "@mui/material";
import Flex from "components/Flex";
import { stringIsValidNumber } from "helpers/utils";
import { FC, useEffect, useState, Dispatch } from "react";

export interface NumericCellProps {
  value: number | undefined;
  setValue: Dispatch<number | undefined>;
  integerOnly: boolean;
  optional: boolean;
  disabled?: boolean;
  inputVariant?: "standard" | "filled" | "outlined";
  label: string;
  variant?: "dense" | "normal";
  error?: boolean;
  sx?: SxProps<Theme>;
  helperText?: string;
}

export const NumericCell: FC<NumericCellProps> = ({
  value,
  setValue,
  integerOnly,
  optional,
  disabled,
  inputVariant,
  label,
  variant,
  error,
  sx,
  helperText,
}) => {
  const [strState, setStrState] = useState(value?.toString() || "");
  useEffect(() => {
    setStrState(value?.toString() || "");
  }, [value]);

  useEffect(() => {
    if (strState === "") setValue(undefined);
    else {
      if (stringIsValidNumber(strState, integerOnly)) {
        setValue(Number.parseFloat(strState));
      } else {
        setValue(undefined);
      }
    }
  }, [strState]);

  const invalidNumber = !stringIsValidNumber(strState, integerOnly);

  return (
    <Flex sx={sx}>
      <TextField
        disabled={disabled}
        variant={inputVariant}
        type={integerOnly ? "number" : "text"}
        error={error}
        inputProps={{
          step: undefined,
        }}
        required={!optional}
        onFocus={(evt) => evt.target.select()}
        onBlur={() => {
          if (value === undefined) {
            setStrState("");
          }
        }}
        helperText={
          variant !== "dense" ? helperText || (invalidNumber && `${integerOnly ? " Whole" : ""} Number`) : undefined
        }
        label={label}
        value={strState}
        onChange={(evt) => {
          const v = evt.target.value;
          setStrState(v);
        }}
      />
    </Flex>
  );
};
